module.exports = __webpack_public_path__ + "static/media/8OLA31.1df6dfa1.jpg";